import { useQuery } from "@tanstack/react-query";
import { adminApi } from "../api";
import { EmptyState, Panel } from "../components/DataTable";

export function ProductsPage() {
  const query = useQuery({ queryKey: ["admin-products"], queryFn: adminApi.products });
  const products = query.data?.products ?? [];
  return (
    <Panel title="Produtos Shopify">
      {!query.data?.connected && <p className="mb-3 rounded-md border border-amber-200 bg-amber-50 p-3 text-sm text-amber-800">Shopify ainda nao conectado. Configure SHOPIFY_STORE_DOMAIN, SHOPIFY_CLIENT_ID e SHOPIFY_CLIENT_SECRET.</p>}
      {!products.length ? <EmptyState text="Nenhum produto carregado." /> : (
        <div className="overflow-auto">
          <table className="w-full min-w-[980px] text-left text-sm">
            <thead className="text-xs uppercase text-slate-500">
              <tr><th className="py-2">Produto</th><th>Status</th><th>Handle</th><th>Estoque</th><th>Variantes</th></tr>
            </thead>
            <tbody>
              {products.map((product) => (
                <tr key={product.id} className="border-t border-line align-top">
                  <td className="py-2">
                    <div className="flex items-center gap-3">
                      {product.featuredMedia?.preview?.image?.url && <img src={product.featuredMedia.preview.image.url} alt="" className="h-10 w-10 rounded-md border border-line object-cover" />}
                      <div><p className="font-semibold">{product.title}</p><p className="font-mono text-xs text-slate-500">{product.id}</p></div>
                    </div>
                  </td>
                  <td>{product.status}</td>
                  <td>{product.handle}</td>
                  <td>{product.totalInventory ?? "-"}</td>
                  <td>
                    <ul className="space-y-1">
                      {product.variants?.nodes?.map((variant: any) => (
                        <li key={variant.id} className="font-mono text-xs">{variant.title} | {variant.sku ?? "sem sku"} | R$ {variant.price} | {variant.inventoryQuantity ?? "-"} un</li>
                      ))}
                    </ul>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Panel>
  );
}
